import { render, staticRenderFns } from "./ownerdeductionrule.vue?vue&type=template&id=5223993d&scoped=true"
import script from "./ownerdeductionrule.vue?vue&type=script&lang=js"
export * from "./ownerdeductionrule.vue?vue&type=script&lang=js"
import style0 from "./ownerdeductionrule.vue?vue&type=style&index=0&id=5223993d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5223993d",
  null
  
)

export default component.exports